<script setup lang="ts">
import FormFornecedor from '../components/form-fornecedor.vue'
import { useFornecedorStore } from '../store/useFornecedorStore'

definePage({
  meta: {
    navActiveLink: 'admin-fornecedor',
    action: 'edit',
    subject: 'fornecedor',
  },
})

const store = useFornecedorStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormFornecedor is-editing />
</template>
